import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";
import {
  getCityByState,
  getCountries,
  getStateByCountry,
  saveUserAddress,
} from "../../../../../testPrepDashboard/Api/DashboardApi";
import CustomTextField from "../../../../../../components/customFields/CustomTextField";
import CustomSelectField from "../../../../../../components/customFields/CustomSelectField";
import ErrorPopupScreen from "../../../../../../components/customPopup/ErrorPopupScreen";
import BlueSmallButton from "../../../../../../components/customButtons/BlueSmallButton";
import SussceeffulyMessageScreen from "../../../../../../components/customPopup/SussceeffulyMessageScreen";

export default function AddNewAddressForm({
  handleClose,
  handleOpenSuccessPopup,
  setSuccessTitle,
  setSubMessage,
}) {
  const userId = localStorage.getItem("userId");
  const firstName = localStorage.getItem("firstName");
  const lastName = localStorage.getItem("lastName");
  const location = useLocation();
  const [billingData, setBillingData] = useState({
    fullName: firstName + "  " + lastName,
    selectedCountry: 101,
    stateId: null,
    cityId: null,
    zipCode: null,
    streetAddress: "",
  });

  const [checked, setChecked] = React.useState(true);
  const [countryList, setCountryList] = useState([]);

  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [buttonTitle, setButtonTitle] = useState(null);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCountries();
        setCountryList(data);
      } catch (err) {
        console.error("Could not fetch country");
        setCountryList([]);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getStateByCountry(billingData?.selectedCountry);
        setStateList(data?.data);
      } catch (err) {
        console.error("Could not fetch State");
        setStateList([]);
      }
    };

    fetchData();
  }, [billingData?.selectedCountry]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCityByState(billingData?.stateId);
        setCityList(data?.data);
      } catch (err) {
        console.error("Could not fetch State");
        setCityList([]);
      }
    };

    fetchData();
  }, [billingData?.stateId]);

  const handleBillingChange = (field, value) => {
    setBillingData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: "", // clear error on change
    }));
  };

  const validateBilling = () => {
    const newErrors = {};
    const {
      fullName,
      selectedCountry,
      stateId,
      cityId,
      zipCode,
      streetAddress,
    } = billingData;

    if (!fullName?.trim()) newErrors.fullName = "Full name is required";
    if (!selectedCountry) newErrors.selectedCountry = "Country is required";
    if (!stateId) newErrors.stateId = "State is required";
    if (!cityId) newErrors.cityId = "City is required";
    if (!zipCode) newErrors.zipCode = "Zip code is required";
    if (!streetAddress.trim())
      newErrors.streetAddress = "Street address is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleSaveAddress = async () => {
    if (validateBilling()) {
      try {
        const response = await saveUserAddress({
          user_id: parseInt(userId),
          name: billingData?.fullName,
          country_id: billingData?.selectedCountry,
          state_id: billingData?.stateId,
          city_id: billingData?.cityId,
          address: billingData?.streetAddress,
          zip_code: billingData?.zipCode,
          is_default: checked,
        });

        console.log("response.statusCode", response.statusCode);
        if (response.statusCode === 201) {
          handleClose();
          handleOpenSuccessPopup();
          setSuccessTitle("Address added successfully !!");
          setSubMessage(
            "Your new address has been added successfully. You can now go to the address list and select the address as needed."
          );
        } else if (response.statusCode === 400) {
          setErrorMessage(response.message);
          handleOpenErrorPopup();
          setButtonTitle("Got It");
          setSubMessage(null);
        } else if (response.statusCode === 500) {
          setErrorMessage(response.message);
          setSubMessage(null);
          handleOpenErrorPopup();
          setButtonTitle("Try Again");
        } else {
          setErrorMessage("Internal Server Error");
          setSubMessage(null);
          handleOpenErrorPopup();
          setButtonTitle("Try Again");
        }
      } catch (error) {
        setErrorMessage("Internal Server Error");
        setSubMessage(null);
        handleOpenErrorPopup();
        setButtonTitle("Try Again");
      }
    } else {
      console.log("Not saved address");
    }
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#222222"
            fontFamily="Inter"
            fontSize="18px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 600 }}
          >
            Enter a Billing Address Details
          </Typography>
        </Grid>

        <Grid item xs={12} mt={1}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Full Name <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomTextField
            value={billingData.fullName}
            onChange={(e) => handleBillingChange("fullName", e.target.value)}
            error={!!errors.fullName}
            helperText={errors.fullName}
            fullWidth
            borderColor="#DDDDDD"
            placeholder="Enter Your Name"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Country <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomSelectField
            options={countryList}
            getOptionLabel={(opt) => opt?.country_name}
            getOptionValue={(opt) => opt?.id}
            value={billingData.selectedCountry}
            onChange={(e) =>
              handleBillingChange("selectedCountry", e.target.value)
            }
            error={!!errors.selectedCountry}
            helperText={errors.selectedCountry}
            fullWidth
            borderColor="#DDDDDD"
            placeholder="select"
            dafualtValue="Select Country"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            State / Union Territory <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomSelectField
            options={
              billingData?.selectedCountry === null && stateList?.length === 0
                ? [
                    {
                      id: "",
                      state_name: "Please select country first",
                      disabled: true,
                    },
                  ]
                : billingData?.selectedCountry !== null &&
                  stateList?.length === 0
                ? [{ id: "", state_name: "No state available", disabled: true }]
                : stateList
            }
            getOptionLabel={(opt) => opt?.state_name}
            getOptionValue={(opt) => opt?.id}
            value={billingData?.stateId}
            onChange={(e) => handleBillingChange("stateId", e.target.value)}
            error={!!errors.stateId}
            helperText={errors.stateId}
            fullWidth
            borderColor="#DDDDDD"
            placeholder="select"
            dafualtValue="Select State"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            City <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomSelectField
            options={
              billingData?.stateId === null && cityList?.length === 0
                ? [
                    {
                      id: "",
                      city_name: "Please select state first",
                      disabled: true,
                    },
                  ]
                : billingData?.stateId !== null && cityList?.length === 0
                ? [{ id: "", city_name: "No city available", disabled: true }]
                : cityList
            }
            getOptionLabel={(opt) => opt?.city_name}
            getOptionValue={(opt) => opt?.id}
            value={billingData?.cityId}
            onChange={(e) => handleBillingChange("cityId", e.target.value)}
            error={!!errors.cityId}
            helperText={errors.cityId}
            fullWidth
            borderColor="#DDDDDD"
            dafualtValue="Select City"
          />
        </Grid>

        <Grid item xs={12} mt={1}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Zip / Postal Code <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomTextField
            type="number"
            value={billingData.zipCode}
            onChange={(e) => handleBillingChange("zipCode", e.target.value)}
            error={!!errors.zipCode}
            helperText={errors.zipCode}
            fullWidth
            borderColor="#DDDDDD"
            placeholder="Enter Zip Code"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography
            textAlign="start"
            color="#444444"
            fontFamily="Inter"
            fontSize="13px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            mb={1}
            style={{ fontWeight: 400 }}
          >
            Street Address (Include landmark)
            <span style={{ color: "#EB0E0E" }}>*</span>
          </Typography>

          <CustomTextField
            value={billingData?.streetAddress}
            onChange={(e) =>
              handleBillingChange("streetAddress", e.target.value)
            }
            error={!!errors.streetAddress}
            helperText={errors.streetAddress}
            fullWidth
            borderColor="#DDDDDD"
            placeholder="Enter Your Address"
          />
        </Grid>

        <Grid item xs={12} sm={6} textAlign="start">
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={handleChange}
                  sx={{
                    "&.Mui-checked": {
                      color: "#572575",
                    },
                  }}
                />
              }
              label="Set as default address"
              sx={{
                "& .MuiFormControlLabel-label": {
                  color: "#572575",
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "14px",
                },
              }}
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12} sm={6} textAlign="end">
          <BlueSmallButton
            buttonTitle="Save Address"
            onClick={handleSaveAddress}
            borderRadius="4px"
          />
        </Grid>
      </Grid>

      <ErrorPopupScreen
        open={openErrorPopup}
        handleClose={handleCloseErrorPopup}
        subText={errorMessage}
        buttonTitle={buttonTitle}
        // startIcon={<ArticleIcon />}
        navigateLink="/test-prep/checkout"
        currentPathname={location.pathname}
        maxWidth="xs"
      />
    </>
  );
}
